import { createContext } from 'react';
import { AUTH_STEP, TAuthSteps } from '../constants';

interface IAuthManagerContextProps {
  step: TAuthSteps;
  setStep: (step: TAuthSteps) => void;
  prefilledEmail?: string;
  setPrefilledEmail: (email: string) => void;
  phone?: {
    phoneWithCallingCode: string;
    phone?: string;
    countryCallingCode?: string;
  };
  setPhone: (phone: {
    phoneWithCallingCode: string;
    phone?: string;
    countryCallingCode?: string;
  }) => void;
}

export const AuthManagerContext =
  createContext<IAuthManagerContextProps | null>({
    step: AUTH_STEP.DEFAULT,
    setStep: () => null,
    prefilledEmail: undefined,
    setPrefilledEmail: () => null,
    phone: undefined,
    setPhone: () => null,
  });
